import { __rest } from "tslib";
import { createSlice } from '@reduxjs/toolkit';
import { api, apiHolder, apis } from 'api';
import { thunkHelperFactory } from '@web-common/utils/redux_utils';
import { FLOLDER } from '@web-mail/common/constant';
import { getIn18Text } from 'api';
const storageApi = apiHolder.api.getDataStoreApi();
const productApi = api.requireLogicalApi(apis.productAuthApiImpl);
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const doListMailBoxEntities = mailApi.doListMailBoxEntities.bind(mailApi);
const doListThreadMailBoxEntities = mailApi.doListThreadMailBoxEntities.bind(mailApi);
export var tabType;
(function (tabType) {
    tabType["readMain"] = "readMain";
    tabType["read"] = "read";
    tabType["reply"] = "reply";
    tabType["replyAll"] = "replyAll";
    tabType["forward"] = "forward";
    tabType["writeCommon"] = "common";
    tabType["replyWithAttach"] = "replyWithAttach";
    tabType["replyAllWithAttach"] = "replyAllWithAttach";
    tabType["forwardAsAttach"] = "forwardAsAttach";
    tabType["edit"] = "edit";
    tabType["editDraft"] = "editDraft";
    tabType["temp"] = "temp";
    tabType["customer"] = "customer";
    tabType["subordinate"] = "subordinate";
    tabType["aiAssistant"] = "aiAssistant";
})(tabType || (tabType = {}));
export var tabId;
(function (tabId) {
    tabId["readMain"] = "-1";
    tabId["readCustomer"] = "-1/-10";
    tabId["readAllCustomer"] = "-1/-101";
    tabId["subordinate"] = "-1/-11";
})(tabId || (tabId = {}));
export const WriteMailTypes = [
    'reply',
    'replyAll',
    'forward',
    'common',
    'replyWithAttach',
    'replyAllWithAttach',
    'replyAllAsNew',
    'forwardAsAttach',
    'edit',
    'editDraft',
];
export const customerTab = {
    id: tabId.readCustomer,
    title: getIn18Text('KEHU2'),
    type: tabType.customer,
    closeable: false,
    isActive: false,
    proxyTitle: getIn18Text(['KEHU', 'YOUJIAN']),
    extra: {
        unRead: 0,
    },
};
export const CustomerAllTab = {
    id: tabId.readAllCustomer,
    title: '全部客户',
    type: tabType.customer,
    closeable: false,
    isActive: false,
    proxyTitle: getIn18Text(['KEHU', 'YOUJIAN']),
    extra: {
        unRead: 0,
        showTab: false,
        from: tabId.readCustomer,
    },
};
export const SubordinateTab = {
    id: tabId.subordinate,
    title: getIn18Text('XIASHU2'),
    type: tabType.subordinate,
    closeable: false,
    isActive: false,
    proxyTitle: getIn18Text(['XIASHU', 'YOUJIAN']),
    extra: {},
};
const ReducerName = 'MailTabReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
const mainTab = {
    id: tabId.readMain,
    title: getIn18Text('SHOUJIANXIANG'),
    type: tabType.readMain,
    closeable: false,
    isActive: true,
    extra: {},
    subTabs: [
        {
            id: '-1/-1',
            title: getIn18Text('YOUJIAN2'),
            proxyTitle: getIn18Text('SHOUJIANXIANG'),
            type: tabType.readMain,
            closeable: false,
            isActive: true,
            extra: {},
        },
    ],
};
const InitialState = {
    currentTab: mainTab,
    tabList: process.env.BUILD_ISEDM ? [mainTab] : [mainTab],
    showMailSidebar: process.env.BUILD_ISEDM ? true : false,
    readTabList: [],
    readTabMidList: {},
    readTabMailList: {},
};
const mailSlice = createSlice({
    name: ReducerName,
    initialState: InitialState,
    reducers: {
        doSetTab: (state, action) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const tabIndex = state.tabList.findIndex(item => item.id === action.payload.id);
            const copy = [...state.tabList];
            if (tabIndex !== -1) {
                if (action.payload) {
                    const oldTab = state.tabList[tabIndex] || {};
                    const newTab = Object.assign(Object.assign({}, oldTab), action.payload);
                    copy.splice(tabIndex, 1, newTab);
                    state.tabList = copy;
                }
            }
            else {
                const id = action.payload.id;
                if (id != null) {
                    if (id.includes('/')) {
                        const path = id.split('/');
                        const tab = state.tabList.find(item => item.id == path[0]);
                        const subTab = (_a = tab === null || tab === void 0 ? void 0 : tab.subTabs) === null || _a === void 0 ? void 0 : _a.find(item => item.id == path[0] + '/' + path[1]);
                        if (subTab) {
                            state.currentTab = subTab;
                        }
                        else if (tab) {
                            (_b = tab === null || tab === void 0 ? void 0 : tab.subTabs) === null || _b === void 0 ? void 0 : _b.push(action.payload);
                        }
                    }
                    else {
                        state.tabList.push(action.payload);
                    }
                }
            }
            if (action.payload) {
                const extra = ((_c = action.payload) === null || _c === void 0 ? void 0 : _c.extra) || {};
                let fromTabId = (_d = state.currentTab) === null || _d === void 0 ? void 0 : _d.id;
                if (((_e = action.payload) === null || _e === void 0 ? void 0 : _e.type) == (tabType === null || tabType === void 0 ? void 0 : tabType.read) && ((_f = state.currentTab) === null || _f === void 0 ? void 0 : _f.type) == tabType.customer) {
                    fromTabId = tabId.readCustomer;
                }
                if (((_g = action.payload) === null || _g === void 0 ? void 0 : _g.type) == (tabType === null || tabType === void 0 ? void 0 : tabType.read) && ((_h = state.currentTab) === null || _h === void 0 ? void 0 : _h.type) == tabType.subordinate) {
                    fromTabId = tabId.subordinate;
                }
                action.payload.extra = Object.assign({ from: fromTabId }, extra);
            }
            if (action.payload.isActive) {
                state.currentTab = action.payload;
            }
        },
        doCloseTab: (state, action) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            const index = state.tabList.findIndex(item => item.id === action.payload);
            const deletedTab = state.tabList[index];
            state.tabList = state.tabList.filter(item => item.id !== action.payload);
            if (action.payload !== state.currentTab.id) {
                return;
            }
            if (WriteMailTypes.includes(deletedTab === null || deletedTab === void 0 ? void 0 : deletedTab.type)) {
                let aimTab;
                if ((deletedTab === null || deletedTab === void 0 ? void 0 : deletedTab.extra) && ((_b = (_a = deletedTab === null || deletedTab === void 0 ? void 0 : deletedTab.extra) === null || _a === void 0 ? void 0 : _a.from) === null || _b === void 0 ? void 0 : _b.includes('/'))) {
                    const path = (_d = (_c = deletedTab === null || deletedTab === void 0 ? void 0 : deletedTab.extra) === null || _c === void 0 ? void 0 : _c.from) === null || _d === void 0 ? void 0 : _d.split('/');
                    const tab = state.tabList.find(item => item.id == path[0]);
                    const subTab = (_e = tab === null || tab === void 0 ? void 0 : tab.subTabs) === null || _e === void 0 ? void 0 : _e.find(item => item.id == path[0] + '/' + path[1]);
                    if (subTab) {
                        aimTab = subTab;
                    }
                }
                else {
                    aimTab = state.tabList.find(item => { var _a; return item.id === ((_a = deletedTab === null || deletedTab === void 0 ? void 0 : deletedTab.extra) === null || _a === void 0 ? void 0 : _a.from); });
                }
                if (aimTab) {
                    state.currentTab = aimTab;
                    return;
                }
            }
            if (state.tabList[index]) {
                state.currentTab = state.tabList[index];
                return;
            }
            if (deletedTab && ((_f = deletedTab === null || deletedTab === void 0 ? void 0 : deletedTab.extra) === null || _f === void 0 ? void 0 : _f.from)) {
                let aimTab;
                if ((deletedTab === null || deletedTab === void 0 ? void 0 : deletedTab.extra) && ((_h = (_g = deletedTab === null || deletedTab === void 0 ? void 0 : deletedTab.extra) === null || _g === void 0 ? void 0 : _g.from) === null || _h === void 0 ? void 0 : _h.includes('/'))) {
                    const path = (_k = (_j = deletedTab === null || deletedTab === void 0 ? void 0 : deletedTab.extra) === null || _j === void 0 ? void 0 : _j.from) === null || _k === void 0 ? void 0 : _k.split('/');
                    const tab = state.tabList.find(item => item.id == path[0]);
                    const subTab = (_l = tab === null || tab === void 0 ? void 0 : tab.subTabs) === null || _l === void 0 ? void 0 : _l.find(item => item.id == path[0] + '/' + path[1]);
                    if (subTab) {
                        aimTab = subTab;
                    }
                }
                else {
                    aimTab = state.tabList.find(item => { var _a; return item.id === ((_a = deletedTab === null || deletedTab === void 0 ? void 0 : deletedTab.extra) === null || _a === void 0 ? void 0 : _a.from); });
                }
                if (aimTab) {
                    state.currentTab = aimTab;
                    return;
                }
            }
            state.currentTab = InitialState.currentTab;
        },
        doBatchCloseTab: (state, action) => {
            var _a, _b, _c, _d;
            const idList = action.payload;
            let activeTabId = state.currentTab.id;
            let readTabdId = '';
            const isReadMailTab = ((_a = state === null || state === void 0 ? void 0 : state.currentTab) === null || _a === void 0 ? void 0 : _a.type) === 'read';
            if (state.currentTab.type === 'read' && activeTabId.includes('_')) {
                readTabdId = ((_b = state.currentTab.extra) === null || _b === void 0 ? void 0 : _b.originMid) || activeTabId.split('_')[0];
            }
            if (idList && Array.isArray(idList) && idList.length) {
                let isDeleteInCurrentTab = false;
                if (readTabdId !== '' && idList.includes(readTabdId)) {
                    isDeleteInCurrentTab = isReadMailTab && idList.length === 1;
                    idList.push(activeTabId);
                }
                if (idList.includes(activeTabId) && !isDeleteInCurrentTab) {
                    let nextTab = null;
                    const activeTabIndex = state.tabList.findIndex(item => item.id === activeTabId);
                    if (activeTabIndex !== 0) {
                        for (let i = activeTabIndex + 1; i < state.tabList.length; i++) {
                            const tabId = (_c = state.tabList[i]) === null || _c === void 0 ? void 0 : _c.id;
                            if (tabId && !idList.includes(tabId)) {
                                nextTab = state.tabList[i];
                                break;
                            }
                        }
                        if (!nextTab) {
                            for (let n = activeTabIndex - 1; n >= 0; n--) {
                                const tabId = (_d = state.tabList[n]) === null || _d === void 0 ? void 0 : _d.id;
                                if (tabId && !idList.includes(tabId)) {
                                    nextTab = state.tabList[n];
                                    break;
                                }
                            }
                        }
                        if (nextTab) {
                            state.currentTab = nextTab;
                        }
                    }
                }
                if (!isDeleteInCurrentTab) {
                    state.tabList = state.tabList.filter(item => !idList.includes(item.id));
                }
            }
        },
        doClearTabs: (state, action) => {
            state.tabList = state.tabList.filter(item => !action.payload.includes(item.id));
        },
        doCleanTabs: (state) => {
            const leftTab = state.tabList.filter(item => !item.closeable);
            state.tabList = [...leftTab];
            state.currentTab = mainTab;
        },
        doUpdateCurrentTab: (state, payload) => {
            const id = payload.payload.id;
            if (!id) {
                return;
            }
            const currentTab = state.currentTab;
            if (currentTab) {
                const currentId = currentTab.id;
                let currentTabInx = state.tabList.findIndex(item => item.id === currentId);
                const oldTabInfo = state.tabList[currentTabInx];
                const newCurrentTab = Object.assign(Object.assign({}, oldTabInfo), payload.payload);
                state.tabList.splice(currentTabInx, 1, newCurrentTab);
                state.currentTab = newCurrentTab;
            }
        },
        doUpdateCMCurrentTab: (state, payload) => {
            var _a, _b, _c, _d;
            const currentTab = state.currentTab;
            const { nextMid, query, accountId } = payload.payload || {};
            if (currentTab && currentTab.type == tabType.read) {
                const currentId = currentTab.id;
                let currentTabInx = state.tabList.findIndex(item => item.id === currentId);
                const oldTabInfo = state.tabList[currentTabInx];
                const extra = Object.assign(Object.assign({}, (oldTabInfo.extra || {})), { originMid: nextMid, query: query, accountId: accountId, cmMidList: [
                        ...(((_a = oldTabInfo.extra) === null || _a === void 0 ? void 0 : _a.cmMidList) || []),
                        {
                            mid: (_b = currentTab.extra) === null || _b === void 0 ? void 0 : _b.originMid,
                            query: (_c = currentTab.extra) === null || _c === void 0 ? void 0 : _c.query,
                            accountId: (_d = currentTab.extra) === null || _d === void 0 ? void 0 : _d.accountId,
                        },
                    ] });
                const newCurrentTab = Object.assign(Object.assign({}, oldTabInfo), { extra, id: nextMid + '_' + new Date().getTime() });
                state.tabList.splice(currentTabInx, 1, newCurrentTab);
                state.currentTab = newCurrentTab;
            }
        },
        doUpdateCMBack: (state, payload) => {
            var _a, _b;
            const currentTab = state.currentTab;
            if (currentTab && currentTab.type == tabType.read) {
                const currentId = currentTab.id;
                let currentTabInx = state.tabList.findIndex(item => item.id === currentId);
                const oldTabInfo = state.tabList[currentTabInx];
                const { mid, query, accountId } = ((_a = oldTabInfo.extra) === null || _a === void 0 ? void 0 : _a.cmMidList.pop()) || {};
                const extra = Object.assign(Object.assign({}, (oldTabInfo.extra || {})), { originMid: mid, query,
                    accountId, cmMidList: (_b = oldTabInfo.extra) === null || _b === void 0 ? void 0 : _b.cmMidList });
                const newCurrentTab = Object.assign(Object.assign({}, oldTabInfo), { extra, id: mid + '_' + new Date().getTime() });
                state.tabList.splice(currentTabInx, 1, newCurrentTab);
                state.currentTab = newCurrentTab;
            }
        },
        doChangeCurrentTab: (state, action) => {
            var _a, _b, _c;
            const id = action.payload;
            if (id.includes('/')) {
                const path = id.split('/');
                const tab = state.tabList.find(item => item.id === path[0]);
                const subTab = (_a = tab === null || tab === void 0 ? void 0 : tab.subTabs) === null || _a === void 0 ? void 0 : _a.find(item => item.id === path[0] + '/' + path[1]);
                if (subTab) {
                    state.currentTab = subTab;
                    state.tabList[0].subTabs = (_b = tab === null || tab === void 0 ? void 0 : tab.subTabs) === null || _b === void 0 ? void 0 : _b.map(sub => {
                        sub.isActive = sub.id === subTab.id;
                        return sub;
                    });
                }
            }
            else if (id === tabId.readMain) {
                const subTab = (_c = state.tabList[0].subTabs) === null || _c === void 0 ? void 0 : _c.find(item => !!item.isActive);
                if (subTab) {
                    state.currentTab = subTab;
                }
            }
            else {
                const tab = state.tabList.find(item => item.id === id);
                if (tab) {
                    state.currentTab = tab;
                }
            }
        },
        doChangeTabById: (state, action) => {
            var _a;
            const { id, tabModel, setCurrent } = action.payload;
            if (id === null || id === void 0 ? void 0 : id.includes('/')) {
                const path = id.split('/');
                const tab = state.tabList.find(item => item.id === path[0]);
                if (tab === null || tab === void 0 ? void 0 : tab.subTabs) {
                    tab.subTabs = (_a = tab === null || tab === void 0 ? void 0 : tab.subTabs) === null || _a === void 0 ? void 0 : _a.map(item => {
                        if (item.id === id) {
                            const newTab = Object.assign(Object.assign({}, item), tabModel);
                            if (setCurrent) {
                                state.currentTab = newTab;
                            }
                            return newTab;
                        }
                        return item;
                    });
                    state.tabList = [...state.tabList];
                }
            }
            else {
                state.tabList = state.tabList.map(item => {
                    if (item.id === id) {
                        const newTab = Object.assign(Object.assign({}, item), tabModel);
                        if (setCurrent) {
                            state.currentTab = newTab;
                        }
                        return newTab;
                    }
                    return item;
                });
            }
        },
        doReplaceTabById: (state, action) => {
            const { recoverCid, id } = action.payload;
            state.tabList = state.tabList.map(item => {
                if (item.id === recoverCid) {
                    const newTab = Object.assign(Object.assign({}, item), { id });
                    if (state.currentTab.id === recoverCid) {
                        state.currentTab = Object.assign(Object.assign({}, state.currentTab), { id });
                    }
                    return newTab;
                }
                return item;
            });
        },
        doReplaceTabId: (state, action) => {
            const { oldId, newId } = action.payload;
            state.tabList = state.tabList.map(item => {
                if (item.id === oldId) {
                    const newTab = Object.assign(Object.assign({}, item), { id: newId });
                    return newTab;
                }
                return item;
            });
            if (state.currentTab.id === oldId) {
                state.currentTab.id = newId;
            }
        },
        doDeleteTabById: (state, action) => {
            const index = state.tabList.findIndex(item => item.id === action.payload);
            if (state.tabList[index - 1].id) {
                state.currentTab = state.tabList[index - 1];
            }
            state.tabList = state.tabList.filter(item => item.id !== action.payload);
        },
        configCustomerTab: (state, action) => {
            var _a, _b, _c, _d;
            if (!productApi.getABSwitchSync('edm_mail')) {
                return;
            }
            const isShow = action.payload;
            const subTabList = state.tabList[0].subTabs || [];
            if (isShow) {
                if (!subTabList.find(tab => tab.id === tabId.readCustomer)) {
                    const tabConfig = Object.assign({}, customerTab);
                    try {
                        const localTask = (_a = storageApi.getSync('atCtTab')) === null || _a === void 0 ? void 0 : _a.data;
                        if (localTask && new Date().getTime() - new Date(+localTask).getTime() < 60000) {
                            tabConfig.isActive = true;
                            state.currentTab = tabConfig;
                            storageApi.del('atCtTab');
                        }
                    }
                    catch (e) {
                        storageApi.del('atCtTab');
                        console.error('[configCustomerTab localTask Error]', e);
                    }
                    subTabList.splice(1, 0, tabConfig, CustomerAllTab);
                }
            }
            else {
                if (((_b = state.currentTab) === null || _b === void 0 ? void 0 : _b.id) == tabId.readCustomer) {
                    state.currentTab = state.tabList[0];
                }
                if (state.tabList && state.tabList.length && ((_c = state.tabList[0]) === null || _c === void 0 ? void 0 : _c.subTabs)) {
                    state.tabList[0].subTabs = (_d = state.tabList[0]) === null || _d === void 0 ? void 0 : _d.subTabs.filter(tab => tab.id !== tabId.readCustomer);
                }
            }
        },
        configSdTab: (state, action) => {
            var _a, _b, _c, _d;
            if (process.env.BUILD_ISEDM && !productApi.getABSwitchSync('edm_mail')) {
                return;
            }
            const isShow = action.payload;
            const subTabList = state.tabList[0].subTabs || [];
            if (isShow) {
                let index = 0;
                subTabList.forEach((tab, i) => {
                    if (tab.id === tabId.readCustomer) {
                        index = i;
                    }
                });
                if (!subTabList.find(tab => tab.id === tabId.subordinate)) {
                    const tabConfig = Object.assign({}, SubordinateTab);
                    try {
                        const localTask = (_a = storageApi.getSync('atSdTab')) === null || _a === void 0 ? void 0 : _a.data;
                        if (localTask && new Date().getTime() - new Date(+localTask).getTime() < 60000) {
                            tabConfig.isActive = true;
                            state.currentTab = tabConfig;
                            storageApi.del('atSdTab');
                        }
                    }
                    catch (e) {
                        storageApi.del('atSdTab');
                        console.error('[configSdTab localTask Error]', e);
                    }
                    subTabList.splice(index + 1, 0, tabConfig);
                }
            }
            else {
                if (((_b = state.currentTab) === null || _b === void 0 ? void 0 : _b.id) == tabId.subordinate) {
                    state.currentTab = state.tabList[0];
                }
                if (state.tabList && state.tabList.length && ((_c = state.tabList[0]) === null || _c === void 0 ? void 0 : _c.subTabs)) {
                    state.tabList[0].subTabs = (_d = state.tabList[0]) === null || _d === void 0 ? void 0 : _d.subTabs.filter(tab => tab.id !== tabId.subordinate);
                }
            }
        },
        doChangeMailSidebar: (state, action) => {
            state.showMailSidebar = action.payload;
        },
        doSetReadTab: (state, action) => {
            const tabIndex = state.readTabList.findIndex(item => item.id === action.payload.id);
            const copy = [...state.readTabList];
            if (tabIndex !== -1) {
                if (action.payload) {
                    const oldTab = state.readTabList[tabIndex] || {};
                    const newTab = Object.assign(Object.assign({}, oldTab), action.payload);
                    copy.splice(tabIndex, 1, newTab);
                    state.readTabList = copy;
                }
            }
            else {
                state.readTabList.push(action.payload);
            }
        },
        doSetReadTabMailList: (state, action) => {
            var _a;
            if ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.length) {
                action.payload.forEach(item => {
                    state.readTabMailList[item.id] = item.title;
                });
            }
        },
        doSetReadTabMidList: (state, action) => {
            state.readTabMidList[action.payload.id] = [...action.payload.midList];
        },
        doSetReadTabCurrentMid: (state, action) => {
            const tabIndex = state.readTabList.findIndex(item => item.id === action.payload.id);
            const copy = [...state.readTabList];
            if (tabIndex !== -1) {
                const oldTab = state.readTabList[tabIndex] || {};
                const newTab = Object.assign(Object.assign({}, oldTab), { currentMid: action.payload.currentMid });
                copy.splice(tabIndex, 1, newTab);
                state.readTabList = copy;
            }
        },
        doDeleteReadTabByCurrentMid: (state, action) => {
            const index = state.readTabList.findIndex(item => item.currentMid === action.payload);
            if (index !== -1 && state.readTabMidList[state.readTabList[index].id]) {
                state.readTabMidList[state.readTabList[index].id] = [];
            }
            state.readTabList = state.readTabList.filter(item => item.currentMid !== action.payload);
        },
        doDeleteReadTabById: (state, action) => {
            const index = state.readTabList.findIndex(item => item.id === action.payload);
            if (index !== -1 && state.readTabMidList[state.readTabList[index].id]) {
                state.readTabMidList[state.readTabList[index].id] = [];
            }
            if (state.readTabMidList[action.payload]) {
                state.readTabMidList[action.payload] = [];
            }
            state.readTabList = state.readTabList.filter(item => item.id !== action.payload);
        },
        doCleanReadTab: (state) => {
            state.readTabMidList = {};
            state.readTabList = [];
            state.readTabMailList = {};
        },
    },
});
thunkHelper({
    name: 'getCurrentReadMail',
    request: async (params, thunkAPI) => {
        const { originTabId = '', currentMid = '', offset = 0 } = params;
        const rootState = thunkAPI.getState();
        const state = rootState.mailTabReducer;
        const { dispatch } = thunkAPI;
        const exceptedFolderIds = [FLOLDER.TASK, FLOLDER.DRAFT, FLOLDER.UNREAD];
        const readTab = state.readTabList.find(item => item.id === originTabId);
        if (readTab) {
            const canLoadMore = !exceptedFolderIds.includes(readTab.query.id) && !readTab.isSearching;
            const tabMidList = state.readTabMidList[originTabId];
            const readMailList = state.readTabMailList;
            if (tabMidList) {
                const currIdx = tabMidList.indexOf(currentMid);
                const prevIdx = currIdx - 1;
                const nextIdx = currIdx + 1;
                if (canLoadMore && !tabMidList[prevIdx]) {
                    dispatch(Thunks.loadMoreReadTabMail({ originTabId, loadPrev: true, index: readTab.query.index - 1 }));
                }
                else if (canLoadMore && !tabMidList[nextIdx]) {
                    dispatch(Thunks.loadMoreReadTabMail({ originTabId, loadNext: true, index: readTab.query.index + 1 }));
                }
                else if (offset !== 0) {
                    dispatch(mailSlice.actions.doSetReadTab(Object.assign(Object.assign({}, readTab), { currentMid, query: Object.assign(Object.assign({}, readTab.query), { index: readTab.query.index + offset }) })));
                }
                return {
                    prevMail: tabMidList[prevIdx] ? { mid: tabMidList[prevIdx], title: readMailList[tabMidList[prevIdx]] } : undefined,
                    currentMail: { mid: currentMid, title: readMailList[currentMid] },
                    nextMail: tabMidList[nextIdx] ? { mid: tabMidList[nextIdx], title: readMailList[tabMidList[nextIdx]] } : undefined,
                };
            }
        }
        return { prevMail: undefined, currentMail: { mid: currentMid, title: '' }, nextMail: undefined };
    },
    fulfilled: (state, action) => {
        const res = action.payload || {};
        return res;
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        console.warn('getMailListRequestParams', error);
    },
});
thunkHelper({
    name: 'loadMoreReadTabMail',
    request: async (params, thunkAPI) => {
        const { originTabId = '', loadPrev = false, loadNext = false, index: currentIdex } = params;
        const rootState = thunkAPI.getState();
        const state = rootState.mailTabReducer;
        const { dispatch } = thunkAPI;
        const _readTab = state.readTabList.find(item => item.id === originTabId);
        const midList = state.readTabMidList[originTabId];
        if (_readTab) {
            const _a = _readTab.query, { count } = _a, other = __rest(_a, ["count"]), { total, isThread } = _readTab;
            let _idx = loadPrev && currentIdex !== 0 ? currentIdex - count : currentIdex;
            if (_idx < 0 || (loadNext && _idx >= total)) {
                return;
            }
            const reqFn = isThread ? doListThreadMailBoxEntities : doListMailBoxEntities;
            reqFn(Object.assign(Object.assign({}, other), { count, index: _idx, _account: other._account }), true)
                .then((res) => {
                if (!isThread) {
                    const mailEntreis = res;
                    if ((other.order && other.order !== 'date') || (other.desc !== undefined && !other.desc)) {
                        const data = mailApi.orderByMailList(mailEntreis.data, Object.assign(Object.assign({}, other), { count }));
                        if (Array.isArray(data)) {
                            mailEntreis.data = data;
                        }
                        else {
                            return {
                                total: data.total,
                                data: data.data,
                                index: _idx,
                                query: other,
                            };
                        }
                    }
                }
                return res;
            })
                .then(res => {
                var _a, _b;
                const readTabMailList = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.map(item => {
                    var _a;
                    return {
                        id: item === null || item === void 0 ? void 0 : item.id,
                        title: ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.title.replace(/<b>/g, '').replace(/<\/b>/g, '')) || getIn18Text('WUZHUTI'),
                    };
                });
                const newReadTab = Object.assign(Object.assign({}, _readTab), { total: (res === null || res === void 0 ? void 0 : res.total) || total });
                const readTabMidList = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.map(item => item.id);
                if (readTabMailList === null || readTabMailList === void 0 ? void 0 : readTabMailList.length) {
                    dispatch(mailSlice.actions.doSetReadTabMailList(readTabMailList));
                }
                if ((readTabMidList === null || readTabMidList === void 0 ? void 0 : readTabMidList.length) && midList) {
                    const midListRes = [...new Set(loadPrev ? readTabMidList.concat(midList) : midList.concat(readTabMidList))];
                    newReadTab.midList = midListRes;
                    dispatch(mailSlice.actions.doSetReadTabMidList({ id: originTabId, midList: midListRes }));
                }
                dispatch(mailSlice.actions.doSetReadTab(newReadTab));
            });
        }
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        console.warn('loadMoreReadTabMail', error);
    },
});
thunkHelper({
    name: 'getReadMailTabIdByMid',
    request: async (params, thunkAPI) => {
        const { mid = '' } = params;
        const rootState = thunkAPI.getState();
        const state = rootState.mailTabReducer;
        const readTab = state.readTabList.find(item => item.currentMid === mid);
        const tab = readTab ? state.tabList.find(item => item.id === readTab.id) : undefined;
        if (readTab && tab) {
            return readTab.id;
        }
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        console.warn('getMailListRequestParams', error);
    },
});
export const { actions } = mailSlice;
export const MailTabThunks = Thunks;
export default mailSlice.reducer;
